import React, { useEffect, useState } from 'react';
import { SquareLoader } from 'react-spinners';

function ImageData({ fileId, onDataChange }) {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (fileId) {
            setIsLoading(true);
            const timestamp = Date.now();

            fetch(`/api/imageinfo/${fileId}?timestamp=${timestamp}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
            })
                .then(response => response.json())
                .then(data => {
                    setIsLoading(false);
                    console.log(data);
                    const { url, width, height, fileid, filename } = data;
                    /* const { width, height } = data.videoinfo.original.video_stream; */
                    onDataChange(url, width, height, fileid, filename); // Вызов функции-колбэка для установки стейтов в родительском компоненте
                })
                .catch(error => {
                    // Обработка ошибок
                    setIsLoading(false);
                    console.error(error);
                });
        }
    }, [fileId, onDataChange]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <SquareLoader color={'#36d7b7'} size={150} loading={isLoading} />
        </div>
    );
}

export default ImageData;